import { $api } from '@service/RequestService';
import { useMutation, useQueryClient } from 'react-query';

import { crmConstants } from '..';

export const useCrmFacebookAppPipeSave = () => {
  const qc = useQueryClient();

  return useMutation(
    async (data: { pageId: number; pipeId?: number; sourceType: string; messenger: string; id?: number }) => {
      const res = await $api.post('/v1/crm/facebook/app-pipe', data);

      return res?.data?.data;
    },
    {
      onSuccess: async () => {
        await qc.invalidateQueries([crmConstants.queryKeys.CRM_FACEBOOK_APP_PIPE]);
      }
    }
  );
};
